<div class="upload-panel" role="dialog" aria-label="Upload theme preview" aria-modal="true">
  <div class="upload-header">
    <span class="upload-title">Upload Theme</span>
    <button
      type="button"
      class="upload-close-btn"
      (click)="onCancel()"
      aria-label="Close upload"
    >&#x2715;</button>
  </div>

  <!-- Theme assignment form fields -->
  <div class="upload-form">
    <div class="form-row">
      <label for="themeName" class="form-label">Theme Name</label>
      <input
        id="themeName"
        type="text"
        class="form-input"
        [(ngModel)]="localThemeName"
        (change)="onThemeNameChange()"
        placeholder="Enter theme name"
        autocomplete="off"
        required
        aria-required="true"
      />
    </div>

    <div class="form-row">
      <label for="themeVersion" class="form-label">
        Version
        <span class="label-hint">(Auto-populated by API)</span>
      </label>
      <input
        id="themeVersion"
        type="text"
        class="form-input"
        [value]="version()"
        readonly
        disabled
        placeholder="Will be set by API"
        aria-readonly="true"
      />
    </div>
  </div>

  <!-- Mode toggle tabs -->
  <div class="upload-mode-tabs" role="tablist" aria-label="Preview mode">
    <button
      type="button"
      class="upload-tab"
      [class.active]="mode() === 'light'"
      (click)="onModeChange('light')"
      role="tab"
      [attr.aria-selected]="mode() === 'light'"
    >Light</button>
    <button
      type="button"
      class="upload-tab"
      [class.active]="mode() === 'dark'"
      (click)="onModeChange('dark')"
      role="tab"
      [attr.aria-selected]="mode() === 'dark'"
    >Dark</button>
  </div>

  <!-- Delta comparison table -->
  <div class="upload-table-wrap">
    @if (deltaRows().length === 0) {
      <p class="upload-empty">No variables found in <strong>{{ mode() }}</strong> mode.</p>
    } @else {
      <table class="upload-table" aria-label="Upload theme preview">
        <caption class="sr-only">All variables in the {{ mode() }} mode theme, comparing the current version with the uploaded version</caption>
        <thead>
          <tr>
            <th scope="col">Key</th>
            <th scope="col">Current Version</th>
            <th scope="col">Uploaded Version</th>
            <th scope="col">Changes</th>
          </tr>
        </thead>
        <tbody>
          @for (row of deltaRows(); track row.variable) {
            <tr
              [class.has-change]="row.hasChange"
              [class.is-new]="row.isNew"
              [class.is-removed]="row.isRemoved"
            >
              <!-- Key -->
              <td class="upload-var-name" [title]="row.variable">{{ row.label }}</td>

              <!-- Current Version (empty when variable is new) -->
              <td class="upload-value upload-current">
                @if (row.before) {
                  <span class="value-chip current-chip" [title]="row.before">
                    @if (isColor(row.before)) {
                      <span class="color-dot" [style.background]="row.before" aria-hidden="true"></span>
                    }
                    {{ row.before }}
                  </span>
                }
              </td>

              <!-- Uploaded Version -->
              <td class="upload-value upload-updated">
                @if (row.after) {
                  <span class="value-chip updated-chip" [title]="row.after">
                    @if (isColor(row.after)) {
                      <span class="color-dot" [style.background]="row.after" aria-hidden="true"></span>
                    }
                    {{ row.after }}
                  </span>
                }
              </td>

              <!-- Changes: green chip when changed, muted "--" when unchanged -->
              <td class="upload-value upload-changes">
                @if (row.hasChange) {
                  <span class="value-chip changes-chip" [title]="row.changes">
                    @if (isColor(row.changes)) {
                      <span class="color-dot" [style.background]="row.changes" aria-hidden="true"></span>
                    }
                    {{ row.changes }}
                  </span>
                } @else {
                  <span class="no-change-dash">--</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <!-- Action buttons -->
  <div class="upload-actions">
    <button
      type="button"
      class="action-btn confirm-btn"
      (click)="onConfirm()"
      [disabled]="!localThemeName.trim()"
    >Confirm Upload</button>
    <button
      type="button"
      class="action-btn cancel-btn"
      (click)="onCancel()"
    >Cancel</button>
  </div>
</div>
